import React from 'react';
import Renderer from 'utilities/Renderer';
import EmbedAppHandler from './handlers/EmbedAppHandler';
import EmbedViewHandler from './handlers/EmbedViewHandler';
import EmbedCardHandler from './handlers/EmbedCardHandler';
import EmbedBanner from './components/EmbedBanner';
import EmbedCardDetails from './components/EmbedCardDetails';
import EmbedCardEndpoints from './components/EmbedCardEndpoints';
import {FeatureDisabled, FEATURE_SWITCHES} from 'components/FeatureSwitch';
import {loadById} from 'state/card/cardActions';
import {RpcEndpointProvider} from 'components/RpcEndpoint';
import {WhenPublic} from 'components/EmbedType';
import {getSearchParam} from '../utilities/URL';

// Request card in parallel with /environment call
const prefetchCard = cardId => Renderer.store.dispatch(loadById(cardId));

const PrivateEmbed = ({cardId}) => (
  <EmbedCardHandler cardId={cardId}>
    <EmbedCardEndpoints cardId={cardId} />
    <EmbedCardDetails cardId={cardId} />
  </EmbedCardHandler>
);

const DavinciEmbed = ({viewId, cardId, pageId, frameStyleId, fitToFrame, viewStyle, ...rest}) => (
  <EmbedCardHandler viewId={viewId} cardId={cardId} frameStyleId={frameStyleId}>
    <EmbedCardDetails
      cardId={cardId}
      pageId={pageId}
      viewId={viewId}
      frameStyleId={frameStyleId}
      fitToFrame={fitToFrame}
      viewStyle={viewStyle}
      {...rest}
    />
  </EmbedCardHandler>
);

const routes = {
  '/embed/card/:externalId'(cardId) {
    prefetchCard(cardId);

    Renderer.render(
      <EmbedAppHandler>
        <PrivateEmbed cardId={cardId} />
      </EmbedAppHandler>
    );
  },

  // This route is used by private embed.
  // The viewId here is just used to map to the cardId.
  '/embed/view/:externalId'(viewId) {
    Renderer.render(
      <EmbedAppHandler>
        <EmbedViewHandler viewId={viewId}>
          {({cardId}) => <PrivateEmbed cardId={cardId} />}
        </EmbedViewHandler>
      </EmbedAppHandler>
    );
  },

  // used by davinci
  '/davinci/:externalId'(viewId) {
    const pageId = getSearchParam('pageId');
    const contextEntityType = getSearchParam('contextEntityType');
    const contextEntityId = getSearchParam('contextEntityId');
    const overriddenStyleId = getSearchParam('overriddenStyleId');
    Renderer.render(
      <EmbedViewHandler viewId={viewId}>
        {({cardId, backgroundId, fitToFrame, viewStyle}) => (
          <DavinciEmbed
            viewId={viewId}
            cardId={cardId}
            pageId={pageId}
            contextEntityType={contextEntityType}
            contextEntityId={contextEntityId}
            overriddenStyleId={overriddenStyleId}
            frameStyleId={backgroundId}
            fitToFrame={fitToFrame}
            viewStyle={viewStyle}
          />
        )}
      </EmbedViewHandler>
    );
  },

  // used by public embed
  '/cards/(.*)'(cardId) {
    Renderer.render(
      <RpcEndpointProvider>
        <EmbedCardHandler cardId={cardId}>
          <EmbedCardEndpoints cardId={cardId} />
          <EmbedCardDetails cardId={cardId} />
          <WhenPublic>
            <FeatureDisabled
              feature={FEATURE_SWITCHES.EMBED_CARD_PUBLIC_WHITELABEL}
            >
              <EmbedBanner cardId={cardId} />
            </FeatureDisabled>
          </WhenPublic>
        </EmbedCardHandler>
      </RpcEndpointProvider>
    );
  },
};

export default routes;
